import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CataloguesService } from '../../core/services/catalogues.service';
import { JobStatistics } from './entities';

@Injectable({
    providedIn: 'root',
})
export class BuilderStatisticsService {
    constructor(private readonly cataloguesService: CataloguesService) {}

    public getJobStatisticsById(connectionId: string): Observable<JobStatistics> {
        return this.cataloguesService
            .getBuilderStatisticsByCustomerId(connectionId)
            .pipe(map((result) => result?.data?.builderStatisticsByCustomerId));
    }
}
